var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DnDContainer',{attrs:{"behaviour":"copy","get-child-payload":_vm.initMaterial}},[_c('Draggable',{staticClass:"material"},[_vm._t("default",[_vm._v(_vm._s(_vm.material.title))])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }